module.exports = __webpack_public_path__ + "assets/img/sdwan-module2-2.80a9b13c.jpg";